export default __webpack_public_path__ + "static/6-small-9f0d296ef73be9127a3cd376263be324.jpg";